(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["exit-intent-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var popup = document.querySelector('[data-exit-popup]');
    if (!popup) return;

    /* Don't show on cart/checkout pages */
    if (/\/(cart|checkout)/.test(window.location.pathname)) return;

    /* Once per session */
    if (sessionStorage.getItem('exit_popup_shown')) return;

    /* --- Smart returning customer detection --- */
    var isReturning = false;
    try { isReturning = localStorage.getItem('poppedijn_has_purchased') === '1'; } catch (e) {}

    var returningCode = popup.dataset.epCodeReturning;
    var returningText = popup.dataset.epTextReturning;

    if (isReturning && returningCode) {
      var codeEl = popup.querySelector('[data-exit-popup-code]');
      var textEl = popup.querySelector('[data-exit-popup-text]');
      if (codeEl) codeEl.textContent = returningCode;
      if (textEl) textEl.textContent = returningText || '';
    }

    /* --- Trigger logic --- */
    var pageLoadTime = Date.now();
    var hasScrolled25 = false;
    var isShown = false;
    var timerMinutes = parseInt(popup.dataset.epTimer, 10) || 15;

    window.addEventListener('scroll', function () {
      var scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
      if (scrollPercent >= 0.25) hasScrolled25 = true;
    }, { passive: true });

    function canShow() {
      return (Date.now() - pageLoadTime) >= 30000 && hasScrolled25 && !isShown;
    }

    /* Focus management: focus naar de sluitknop bij openen, terug bij sluiten, Tab blijft binnen */
    var prevFocus = null;
    function onTrapKeydown(e) {
      if (e.key === 'Escape') { hidePopup(); return; }
      if (e.key !== 'Tab') return;
      var focusables = popup.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function showPopup() {
      if (!canShow()) return;
      isShown = true;
      popup.style.display = '';
      try { sessionStorage.setItem('exit_popup_shown', '1'); } catch (err) { /* private mode */ }
      startCountdown();
      prevFocus = document.activeElement;
      popup.addEventListener('keydown', onTrapKeydown);
      var closeBtn = popup.querySelector('.exit-popup__close');
      if (closeBtn) closeBtn.focus();
    }

    function hidePopup() {
      popup.style.display = 'none';
      popup.removeEventListener('keydown', onTrapKeydown);
      if (prevFocus && typeof prevFocus.focus === 'function') prevFocus.focus();
    }

    /* Desktop: mouse leaves viewport toward top (with 500ms delay to avoid false triggers) */
    var mouseLeftTimer = null;
    document.addEventListener('mouseout', function (e) {
      if (e.clientY <= 5 && e.relatedTarget == null) {
        mouseLeftTimer = setTimeout(function () { showPopup(); }, 500);
      }
    });
    document.addEventListener('mouseenter', function () {
      if (mouseLeftTimer) { clearTimeout(mouseLeftTimer); mouseLeftTimer = null; }
    });

    /* Mobile: detect fast scroll-up as exit signal (touch devices only) */
    var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouchDevice) {
      var mobLastY = 0;
      var mobLastTime = 0;
      var mobScrollUpDist = 0;
      var mobMaxScrollY = 0;
      var mobResetTimer = null;
      var pageHeight = function () { return document.documentElement.scrollHeight - window.innerHeight; };

      window.addEventListener('scroll', function () {
        var currentY = window.scrollY;
        var now = Date.now();

        if (currentY > mobMaxScrollY) mobMaxScrollY = currentY;

        var scrolledDownEnough = pageHeight() > 0 && (mobMaxScrollY / pageHeight()) >= 0.4;

        if (currentY < mobLastY && scrolledDownEnough) {
          var delta = mobLastY - currentY;
          var elapsed = now - mobLastTime;
          var velocity = elapsed > 0 ? delta / elapsed : 0;

          if (velocity > 0.8) {
            mobScrollUpDist += delta;
          } else {
            mobScrollUpDist = 0;
          }

          if (mobScrollUpDist >= 600) {
            showPopup();
            mobScrollUpDist = 0;
          }
        } else if (currentY > mobLastY) {
          mobScrollUpDist = 0;
        }

        mobLastY = currentY;
        mobLastTime = now;

        if (mobResetTimer) clearTimeout(mobResetTimer);
        mobResetTimer = setTimeout(function () { mobScrollUpDist = 0; }, 1500);
      }, { passive: true });
    }

    /* Close handlers */
    popup.querySelectorAll('[data-exit-popup-close]').forEach(function (el) {
      el.addEventListener('click', hidePopup);
    });

    /* Copy code (with fallback) */
    function copyToClipboard(text, onSuccess) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(onSuccess).catch(fallback);
      } else {
        fallback();
      }
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.cssText = 'position:fixed;left:-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); onSuccess(); } catch (e) {}
        document.body.removeChild(ta);
      }
    }

    var copyBtn = popup.querySelector('[data-exit-popup-copy]');
    var codeElCopy = popup.querySelector('[data-exit-popup-code]');
    if (copyBtn && codeElCopy) {
      copyBtn.addEventListener('click', function () {
        copyToClipboard(codeElCopy.textContent.trim(), function () {
          copyBtn.textContent = 'Gekopieerd!';
          setTimeout(function () { copyBtn.textContent = 'Code kopiëren'; }, 2000);
        });
      });
    }

    /* Configurable countdown */
    function startCountdown() {
      var countdownEl = popup.querySelector('[data-exit-popup-countdown]');
      if (!countdownEl) return;
      var remaining = timerMinutes * 60;
      var timer = setInterval(function () {
        remaining--;
        if (remaining <= 0) { clearInterval(timer); hidePopup(); return; }
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        countdownEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      }, 1000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
